import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
const NewExampleWell = styled(Well)(
  ({ theme }) => css`
    margin-bottom: 5px;
    font-family: ${theme.fonts.family.monospace};
    font-size: ${theme.fonts.size.body};
    white-space: pre-wrap;
    overflow-wrap: break-word;
  `
);
const TeamsNotificationDetails = ({ notification }) => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("teams_notification_v2_details.webhook_url_label"),
      value: notification.config.webhook_url
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("teams_notification_v2_details.adaptive_card_label"),
      value: /* @__PURE__ */ React.createElement(NewExampleWell, { bsSize: "small" }, notification.config.adaptive_card)
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("teams_notification_v2_details.backlog_limit_label"),
      value: notification.config.backlog_size
    }
  ));
};
export default TeamsNotificationDetails;
